import { render, staticRenderFns } from "./PurD_Delivery.vue?vue&type=template&id=01ca73f4"
import script from "./PurD_Delivery.vue?vue&type=script&lang=js"
export * from "./PurD_Delivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports